export default __webpack_public_path__ + "static/media/payment-blank-visa.7a2d3804.svg";